<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="mContent__header bg-primary py-3 px-5 flex-auto">
  <h1 class="text-white mb-1">School Directory</h1>
  <div class="mControls">
    <div class="input-group mr-auto">
      <mat-form-field appearance="outline" class="input-white no-error">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          type="text"
          matInput
          [(ngModel)]="schoolInfo.search"
          (keyup.enter)="onSearch()"
          placeholder="Search by name"
          aria-label="Search"
        />
        <button
          mat-button
          *ngIf="schoolInfo.search"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="schoolInfo.search = ''; onSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div *ngIf="loggedInUser !== tutorRoleId">
      <div class="mControls__right">
        <div>
          <button mat-raised-button (click)="updateSchool(null)">
            Add New
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="schools?.length > 0"
  class="search-results flex-fill overflow-auto m-3"
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="1000"
  (scrolled)="onScroll()"
  [scrollWindow]="false"
>
  <table class="table no-wrap m-0 table--hover">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">School Contact</th>
        <th scope="col" style="width: 100px">Email</th>
        <th scope="col" style="width: 60px">&nbsp;</th>
        <th scope="col" style="width: 60px">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let school of schools">
        <td (click)="schoolDetails(school.id)">
          {{ school.school_name }} ({{ school.uuid }})
        </td>
        <td (click)="schoolDetails(school.id)">
          {{ school.clarity_person_name }}
        </td>
        <td (click)="schoolDetails(school.id)">
          {{ school.clarity_person_email }}
        </td>
        <div *ngIf="loggedInUser !== tutorRoleId">
          <td>
            <a
              class="cursor-pointer icon-btn"
              (click)="updateSchool(school.id)"
              aria-hidden="false"
              aria-label="Edit"
            >
              <mat-icon matTooltip="Edit" aria-hidden="false" aria-label="Edit"
                >edit</mat-icon
              >
            </a>
          </td>
          <td>
            <a
              class="cursor-pointer icon-btn"
              (click)="deleteSchool(school)"
              aria-hidden="false"
              aria-label="Delete"
            >
              <mat-icon
                matTooltip="Delete"
                aria-hidden="false"
                aria-label="Delete"
                >delete</mat-icon
              >
            </a>
          </td>
        </div>
      </tr>
    </tbody>
  </table>
</div>
<div
  class="flex-fill d-flex flex-column align-items-center justify-content-center"
  *ngIf="!schools?.length"
>
  <img src="assets/images/no-result.png" alt="" />
  <h3 class="text-center">No Records found</h3>
</div>
<div class="text-right flex-auto p-3 page-count">
  <span>{{ schools?.length }}</span> of <span>{{ count }}</span>
</div>
